module.exports = __webpack_public_path__ + "img/pizza-4.10f0b341.jpg";